<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-contact-reasons-detail-metrics">
    <table class="metrics-table" border="0" cellspacing="0" cellpadding="0">
    <tr>
      <td v-if="showSection('totalVolume')" v-bind:class="isSelectedChart('totalVolume')" @click="handleSelectChart('totalVolume')">
        <div class="title">{{getTitle('totalVolume')}}</div>
        <div class="value" v-bind:class="{multiLines:showingTwoLine, hidden: showingTwoLineHidden}">
          <div class="total">{{formatNumber(topicData.totalVolumeDMValue, 0)}}</div>
          <div v-if="topicData.volumeChangePercent && topicData.volumeChangeWithoutAbs!=0" v-bind:class="{change: true, up: topicData.volumeChangeWithoutAbs>0,  down: topicData.volumeChangeWithoutAbs<0}">{{formaterNumber(topicData.volumeChangePercent)}}%<span class="icon"></span></div>
          <div v-else-if="topicData.volumeChangePercent && topicData.volumeChangeWithoutAbs==0" class="change">No Change</div>
          <div v-else class="change">N/A</div>
        </div>
        <div class="compare" v-if="topicData.volumeChangePercent">
           <span v-if="topicData.volumeChangeWithoutAbs<0">compared to {{formatNumber(topicData.totalVolumeCompareDMValue, 0)}} over the previous {{topicData.numOfDaysInRange}} days</span>
           <span v-else-if="topicData.volumeChangeWithoutAbs>0">compared to {{formatNumber(topicData.totalVolumeCompareDMValue, 0)}} over the previous {{topicData.numOfDaysInRange}} days</span>
           <span v-else class="no-data">compared to {{formatNumber(topicData.totalVolumeCompareDMValue, 0)}} over the previous {{topicData.numOfDaysInRange}} days</span>
        </div>
        <div class="compare" v-else>
          <span class="no-data">Correct comparison not available for this time period</span>
        </div>
      </td>

      <td v-if="showSection('totalContainmentPercent')"  v-bind:class="isSelectedChart('totalContainmentPercent')" @click="handleSelectChart('totalContainmentPercent')">
        <div class="title">{{getTitle('totalContainmentPercent')}}</div>
        <div class="value" v-bind:class="{multiLines:showingTwoLine, hidden: showingTwoLineHidden}">
          <div class="total">{{formaterNumber(topicData.totalContainmentPercent)}}%</div>
          <div v-if="topicData.containmentChangePercent==null || topicData.containmentChangeDisplay && (topicData.containmentChangeDisplay == 'NaN' || topicData.containmentChangeDisplay == '+Infinity')" class="change">N/A</div>
          <div v-else-if="topicData.containmentChangeWithoutAbs!=0" v-bind:class="{change: true,  up: topicData.containmentChangeWithoutAbs>0,  down: topicData.containmentChangeWithoutAbs<0}">{{formaterNumber(topicData.containmentChangePercent)}}%<span class="icon"></span></div>
          <div v-else-if="topicData.containmentChangeWithoutAbs==0" class="change">No Change</div>
          <div v-else class="change">N/A</div>
        </div>
        <div class="compare" v-if="topicData.totalContainmentPercentCompare && topicData.totalContainmentPercentCompare==0" >
          <span class="no-data">Correct comparison not available for this time period</span>
        </div>
        <div class="compare" v-else-if="topicData.containmentChangePercent==null || topicData.containmentChangeDisplay && (topicData.containmentChangeDisplay == 'NaN' || topicData.containmentChangeDisplay == '+Infinity')">
          <span class="no-data">Correct comparison not available for this time period</span>
        </div>
         <div class="compare" v-else>
          <span v-if="topicData.containmentChangeWithoutAbs<0">compared to {{formaterNumber(topicData.totalContainmentPercentCompare)}}% over the previous {{topicData.numOfDaysInRange}} days</span>
          <span v-else-if="topicData.containmentChangeWithoutAbs>0">compared to {{formaterNumber(topicData.totalContainmentPercentCompare)}}% over the previous {{topicData.numOfDaysInRange}} days</span>
          <span v-else class="no-data">compared to {{topicData.totalContainmentPercentCompare}}% over the previous {{topicData.numOfDaysInRange}} days</span>
        </div>
      </td>

      <td v-if="showSection('avgHandlingTime')"  v-bind:class="isSelectedChart('avgHandlingTime')" @click="handleSelectChart('avgHandlingTime')">
        <div class="title">{{getTitle('avgHandlingTime')}}</div>
        <div class="value" v-bind:class="{multiLines:showingTwoLine, hidden: showingTwoLineHidden}">
          <div class="total">{{topicData.avgHandlingTimeDisplay}}</div>
          <div v-if="topicData.avgHandlingTimeChangePercent && topicData.avgHandlingTimeChangeWithoutAbs!=0" v-bind:class="{change: true, up: topicData.avgHandlingTimeChangeWithoutAbs>0,  down: topicData.avgHandlingTimeChangeWithoutAbs<0}">{{formaterNumber(topicData.avgHandlingTimeChangePercent)}}%<span class="icon"></span></div>
          <div v-else-if="topicData.avgHandlingTimeChangePercent && topicData.avgHandlingTimeChangeWithoutAbs==0" class="change">No Change</div>
          <div v-else class="change">N/A</div>
        </div>
        <div class="compare" v-if="topicData.avgHandlingTimeChangePercent">
          <span v-if="topicData.avgHandlingTimeChangeWithoutAbs<0">compared to {{topicData.avgHandlingTimeCompareDisplay}} over the previous {{topicData.numOfDaysInRange}} days</span>
          <span v-else-if="topicData.avgHandlingTimeChangeWithoutAbs>0">compared to {{topicData.avgHandlingTimeCompareDisplay}} over the previous {{topicData.numOfDaysInRange}} days</span>
          <span v-else class="no-data">compared to {{topicData.avgHandlingTimeCompareDisplay}} over the previous {{topicData.numOfDaysInRange}} days</span>
        </div>
        <div class="compare" v-else>
          <span class="no-data">Correct comparison not available for this time period</span>
        </div>
      </td>

      <td  v-if="!isHideResponse || showSection('avgResponseTime')" v-bind:class="isSelectedChart('avgResponseTime')" @click="handleSelectChart('avgResponseTime')">
        <div class="title">{{getTitle('avgResponseTime')}}</div>
        <div class="value" v-bind:class="{multiLines:showingTwoLine, hidden: showingTwoLineHidden}">
          <div class="total">{{topicData.avgResponseTimeDisplay}}</div>
          <div v-if="topicData.avgResponseTimeChangePercent && topicData.avgResponseTimeChangeWithoutAbs!=0" v-bind:class="{change: true, up: topicData.avgResponseTimeChangeWithoutAbs>0,  down: topicData.avgResponseTimeChangeWithoutAbs<0}">{{formaterNumber(topicData.avgResponseTimeChangePercent)}}%<span class="icon"></span></div>
          <div v-else-if="topicData.avgResponseTimeChangePercent && topicData.avgResponseTimeChangeWithoutAbs==0" class="change">No Change</div>
          <div v-else class="change">N/A</div>
        </div>
        <div class="compare" v-if="topicData.avgResponseTimeChangePercent">
          <div v-if="topicData.avgResponseTimeChangeWithoutAbs<0">compared to {{topicData.avgResponseTimeCompareDisplay}} over the previous {{topicData.numOfDaysInRange}} days</div>
          <div v-else-if="topicData.avgResponseTimeChangeWithoutAbs>0">compared to {{topicData.avgResponseTimeCompareDisplay}} over the previous {{topicData.numOfDaysInRange}} days</div>
          <div v-else class="no-data">compared to {{topicData.avgResponseTimeCompareDisplay}} over the previous {{topicData.numOfDaysInRange}} days</div>
        </div>
         <div class="compare" v-else>
          <span class="no-data">Correct comparison not available for this time period</span>
        </div>
      </td>

      <td  v-if="showSection('totalPositivePercent')" v-bind:class="isSelectedChart('totalPositivePercent')" @click="handleSelectChart('totalPositivePercent')">
        <div class="title">{{getTitle('totalPositivePercent')}}</div>
        <div class="value" v-bind:class="{multiLines:showingTwoLine, hidden: showingTwoLineHidden}">
          <div class="total">{{formaterNumber(topicData.totalPositivePercent)}}%</div>
          <div v-if="topicData.sentimentPositiveChangePercent==null || topicData.sentimentPositiveChangeDisplay && (topicData.sentimentPositiveChangeDisplay == 'NaN' || topicData.sentimentPositiveChangeDisplay == '+Infinity')" class="change">N/A</div>
          <div v-else-if="topicData.sentimentPositiveChangeWithoutAbs!=0" v-bind:class="{change: true, up: topicData.sentimentPositiveChangeWithoutAbs>0,  down: topicData.sentimentPositiveChangeWithoutAbs<0}">{{formaterNumber(topicData.sentimentPositiveChangePercent)}}%<span class="icon"></span></div>
          <div v-else-if="topicData.sentimentPositiveChangeWithoutAbs==0" class="change">No Change</div>
          <div v-else class="change">N/A</div>
        </div>
        <div class="compare" v-if="topicData.totalPositivePercentCompare && topicData.totalPositivePercentCompare==0" >
          <span class="no-data">Correct comparison not available for this time period</span>
        </div>
        <div class="compare" v-else-if="topicData.sentimentPositiveChangePercent==null || topicData.sentimentPositiveChangeDisplay && (topicData.sentimentPositiveChangeDisplay == 'NaN' || topicData.sentimentPositiveChangeDisplay == '+Infinity')">
          <span class="no-data">Correct comparison not available for this time period</span>
        </div>
         <div class="compare" v-else>
          <span v-if="topicData.sentimentPositiveChangeWithoutAbs<0">compared to {{formaterNumber(topicData.totalPositivePercentCompare)}}% over the previous {{topicData.numOfDaysInRange}} days</span>
          <span v-else-if="topicData.sentimentPositiveChangeWithoutAbs>0">compared to {{formaterNumber(topicData.totalPositivePercentCompare)}}% over the previous {{topicData.numOfDaysInRange}} days</span>
          <span v-else class="no-data">compared to {{topicData.totalPositivePercentCompare}}% over the previous {{topicData.numOfDaysInRange}} days</span>
        </div>
      </td>

      <td  v-if="showSection('totalNegativePercent')" v-bind:class="isSelectedChart('totalNegativePercent')" @click="handleSelectChart('totalNegativePercent')">
        <div class="title">{{getTitle('totalNegativePercent')}}</div>
        <div class="value" v-bind:class="{multiLines:showingTwoLine, hidden: showingTwoLineHidden}">
          <div class="total">{{formaterNumber(topicData.totalNegativePercent)}}%</div>
          <div v-if="topicData.sentimentNegativeChangePercent==null || topicData.sentimentNegativeChangeDisplay && (topicData.sentimentNegativeChangeDisplay == 'NaN' || topicData.sentimentNegativeChangeDisplay == '+Infinity')" class="change">N/A</div>
          <div v-else-if="topicData.sentimentNegativeChangeWithoutAbs!=0" v-bind:class="{change: true, up: topicData.sentimentNegativeChangeWithoutAbs>0,  down: topicData.sentimentNegativeChangeWithoutAbs<0}">{{formaterNumber(topicData.sentimentNegativeChangePercent)}}%<span class="icon"></span></div>
          <div v-else-if="topicData.sentimentNegativeChangeWithoutAbs==0" class="change">No Change</div>
          <div v-else class="change">N/A</div>
        </div>
        <div class="compare" v-if="topicData.totalNegativePercentCompare && topicData.totalNegativePercentCompare==0" >
          <span class="no-data">Correct comparison not available for this time period</span>
        </div>
        <div class="compare" v-else-if="topicData.sentimentNegativeChangePercent==null || topicData.sentimentNegativeChangeDisplay && (topicData.sentimentNegativeChangeDisplay == 'NaN' || topicData.sentimentNegativeChangeDisplay == '+Infinity')">
          <span class="no-data">Correct comparison not available for this time period</span>
        </div>
        <div class="compare" v-else>
          <span v-if="topicData.sentimentNegativeChangeWithoutAbs<0">compared to {{formaterNumber(topicData.totalNegativePercentCompare)}}% over the previous {{topicData.numOfDaysInRange}} days</span>
          <span v-else-if="topicData.sentimentNegativeChangeWithoutAbs>0">compared to {{formaterNumber(topicData.totalNegativePercentCompare)}}% over the previous {{topicData.numOfDaysInRange}} days</span>
          <span v-else class="no-data">compared to {{topicData.totalNegativePercentCompare}}% over the previous {{topicData.numOfDaysInRange}} days</span>
        </div>
      </td>

      <!-- hide for OC-1171
      <td v-if="showSection('avgTransfers')" v-bind:class="isSelectedChart('avgTransfers')" @click="handleSelectChart('avgTransfers')">
        <div class="title">{{getTitle('avgTransfers')}}</div>
        <div class="value" v-bind:class="{multiLines:showingTwoLine, hidden: showingTwoLineHidden}">
          <div class="total">{{topicData.avgTransfers}}</div>
          <div v-if="topicData.avgTransfersChangePercent && topicData.avgTransfersChangeWithoutAbs!=0" v-bind:class="{change: true, up: topicData.avgTransfersChangeWithoutAbs>0,  down: topicData.avgTransfersChangeWithoutAbs<0}">{{formaterNumber(topicData.avgTransfersChangePercent)}}%<span class="icon"></span></div>
          <div v-else-if="topicData.avgTransfersChangePercent && topicData.avgTransfersChangeWithoutAbs==0" class="change">No Change</div>
          <div v-else class="change">N/A</div>
        </div>
        <div class="compare" v-if="topicData.avgTransfersChangePercent">
          <span v-if="topicData.avgTransfersChangeWithoutAbs<0">compared to {{formaterNumber(topicData.avgTransfersCompare)}} over the previous {{topicData.numOfDaysInRange}} days</span>
          <span v-else-if="topicData.avgTransfersChangeWithoutAbs>0">compared to {{formaterNumber(topicData.avgTransfersCompare)}} over the previous {{topicData.numOfDaysInRange}} days</span>
          <span v-else class="no-data">compared to {{formaterNumber(topicData.avgTransfersCompare)}} over the previous {{topicData.numOfDaysInRange}} days</span>
        </div>
        <div class="compare" v-else>
          <span class="no-data">Correct comparison not available for this time period</span>
        </div>
      </td>
      -->
    </tr>
    </table>
    
    <div ref="detailMetricsCharts" class="charts">
      <div class="toolbar">
        <el-button class="viewCharts" type="primary" @click="handleViewCharts">{{viewALLCharts ? "Collapse all trends" : "Show all trends"}}</el-button>
      </div>

      <div class="chart totalVolumeChart" v-if="(viewALLCharts || selectedChart=='totalVolume') && showChart">
        <detailMetricsChart :parent="module" ref="totalVolume" :activeTab="activeTab" :selectedChart="selectedChart" :viewType="viewType" id="totalVolume" title="Volume" column="sumVolumeDMValue" :data="topicData" format="0,0" suffix="" :parentLoading='loading' />
      </div>
      <div class="chart totalContainmentPercent" v-if="showSection('totalContainmentPercent') && (viewALLCharts || selectedChart=='totalContainmentPercent')  && showChart">
        <detailMetricsChart :parent="module" ref="totalContainmentPercent" :activeTab="activeTab" :selectedChart="selectedChart" :viewType="viewType" id="totalContainmentPercent" title="Containment Rate" column="sumContainmentPercent" :data="topicData" format="0.00" suffix="%" :parentLoading='loading' />
      </div>
      <div class="chart avgHandlingTime" v-if="(viewALLCharts || selectedChart=='avgHandlingTime') && showChart">
        <detailMetricsChart :parent="module" ref="avgHandlingTime" :activeTab="activeTab" :selectedChart="selectedChart" :viewType="viewType" id="avgHandlingTime" title="Average Total Handle Time" column="sumHandlingTime" :data="topicData" format="time" suffix="m" :parentLoading='loading' />
      </div>
      <div class="chart avgResponseTime" v-if="!isHideResponse && (viewALLCharts || selectedChart=='avgResponseTime') && showChart">
        <detailMetricsChart :parent="module" ref="avgResponseTime" :activeTab="activeTab" :selectedChart="selectedChart" :viewType="viewType" id="avgResponseTime" title="Average Agent Response Time" column="sumResponseTime" :data="topicData" format="time" suffix="m" :parentLoading='loading' />
      </div>
      <div class="chart totalPositivePercent" v-if="(viewALLCharts || selectedChart=='totalPositivePercent') && showChart">
        <detailMetricsChart :parent="module" ref="totalPositivePercent" :activeTab="activeTab" :selectedChart="selectedChart" :viewType="viewType" id="totalPositivePercent" title="Positive Sentiment" column="sumPositivePercent" :data="topicData" format="0.00" suffix="%" :parentLoading='loading' />
      </div>
      <div class="chart totalNegativePercent" v-if="(viewALLCharts || selectedChart=='totalNegativePercent') && showChart">
        <detailMetricsChart :parent="module" ref="totalNegativePercent" :activeTab="activeTab" :selectedChart="selectedChart" :viewType="viewType" id="totalNegativePercent" title="Negative Sentiment" column="sumNegativePercent" :data="topicData" format="0.00" suffix="%" :parentLoading='loading' />
      </div>
      <!-- hide for OC-1171
      <div class="chart avgTransfersChart" v-if="showSection('avgTransfers') && (viewALLCharts || selectedChart=='avgTransfers') && showChart">
        <detailMetricsChart :parent="module" ref="avgTransfers" :activeTab="activeTab" :selectedChart="selectedChart" :viewType="viewType" id="avgTransfers" title="Average Handoffs" column="avgTransfers" :data="topicData" suffix="" :parentLoading='loading' />
      </div>
      -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import WyUtils from '../../library/wy-utils.js';
import detailMetricsChart from './wy-analytics-contact-reasons-detail-metrics-chart';

export default Vue.extend({
  name: 'wy-analytics-contact-reasons-detail',
  props: ['parent', 'activeTab'],

  components: {
    'detailMetricsChart': detailMetricsChart,
  },
  
  data() {
    return {
      module: this,
      loading: false,
      initDate: null,
      topicData: {},
      selectedChart: 'totalVolume',
      viewALLCharts: false,
      showingTwoLine: false,
      showingTwoLineHidden: false,
      preWindowWidth:0,
      showChart: true,

      titles: {
        'totalVolume': 'Volume',
        'totalContainmentPercent': 'Containment Rate',
        'avgHandlingTime': 'Average Total Handle Time',
        'avgResponseTime': 'Average Agent Response Time',
        'totalPositivePercent': 'Positive Sentiment',
        'totalNegativePercent': 'Negative Sentiment',
        'avgTransfers': 'Average Handoffs'
      },

      viewType: null,
      fetchData: true
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'tableModel', 'isHideResponse'])
  },

  methods: {
    ...mapActions(['fetchContactReasonsTopicTrend']),

    handleViewTypeChange(viewType) {
      this.viewType = viewType;
    },

    getTitle(key) {
      return this.titles[key];
    },

    showSection(sectionName) {
      let isShow = true;
      this.dataModel.columns.forEach(column => {
        if(column.name == sectionName) {
          if(column.hide){
            isShow = false;
          }
        }
      });
      return isShow;
    },

    startLoading() {
      this.loadData();
      this.initDate = new Date();
      this.resizeWindowHandler();
      if(!this.loading) {
        this.logEventLoaded();
      }
    },

    logEventLoaded() {
      if(this.initDate) {
        this.$store.dispatch('amplitudeLogWithFilters', {name: 'metrics_loaded', data: {topic_name: this.topicData.topicDisplayName, data_load_time: WyUtils.getTimeDiff(this.initDate)}});
        this.initDate = null;
      }
    },

    formatNumber(val, dec=2) {
      return val!=null ? WyUtils.formatterNumber(val.toFixed(dec)) : 0;
    },

    formaterNumber(value) {
      let formatValue = '';
      if(typeof value == "number") {
        formatValue = WyUtils.formatterFloatNumber(value);
      }
      else {
        formatValue = WyUtils.formatterFloatNumber(parseFloat(value));
      }
      return formatValue;
    },

    isSelectedChart(chart) {
      return {
        selected: this.selectedChart==chart,
        showAllChart: this.viewALLCharts,
      };
    },

    handleSelectChart(key) {
      this.selectedChart = key;
      this.viewALLCharts = false;
      this.$store.dispatch('amplitudeLogWithFilters', {name: 'metric_clicked', data: {topic_name: this.topicData.topicDisplayName, metric_name: this.getTitle(key)}});
    },

    handleViewCharts() {
      this.viewALLCharts = !this.viewALLCharts;
      this.showChart = false;
      setTimeout(()=>{
        this.showChart = true;
      },300)
      if(this.viewALLCharts) {
        this.$store.dispatch('amplitudeLogWithFilters', {name: 'metrics_show_all_trends_clicked', data: {topic_name: this.topicData.topicDisplayName}});
      }
      else {
        this.$store.dispatch('amplitudeLogWithFilters', {name: 'metrics_collapse_trends_clicked', data: {topic_name: this.topicData.topicDisplayName}});
      }
    },

    async loadData() {
      if(this.fetchData) {
        this.loading = true;
        this.topicData = this.parent.currentItem;
        let result = await this.fetchContactReasonsTopicTrend({topics: this.parent.currentItem.mergedTopics, topicDisplayName: this.parent.currentItem.topicDisplayName});
        if(result.data && result.data.length > 0) {
          this.topicData.trend = result.data;
          this.topicData.trend.forEach(item => {
            item.sumVolumeDMValue = (item.sumVolume!=null ? item.sumVolume * this.$store.getters.xnumber: item.sumVolume);
          })
        }
        this.loading = false; 

        if(this.$refs.totalVolume) this.$refs.totalVolume.changeDateRange(this.viewType);
        if(this.$refs.avgHandlingTime) this.$refs.avgHandlingTime.changeDateRange(this.viewType);
        if(this.$refs.avgResponseTime) this.$refs.avgResponseTime.changeDateRange(this.viewType);
        if(this.$refs.totalPositivePercent) this.$refs.totalPositivePercent.changeDateRange(this.viewType);
        if(this.$refs.totalNegativePercent) this.$refs.totalNegativePercent.changeDateRange(this.viewType);
        if(this.$refs.totalContainmentPercent) this.$refs.totalContainmentPercent.changeDateRange(this.viewType);
        if(this.$refs.avgTransfers) this.$refs.avgTransfers.changeDateRange(this.viewType);
        
        this.parent.stopLoadingByTab('metrics');
        this.logEventLoaded();
        this.fetchData = false;
      }
    },

    resizeWindowHandler() {
      if(Math.abs(this.preWindowWidth - window.innerWidth) > 5) {
        this.showingTwoLineHidden = true;
        this.showingTwoLine = false;
        setTimeout(()=>{
          let tds = document.querySelectorAll('.metrics-table tr > td > div:nth-child(2) > div:nth-child(2)');
          if(tds){
            let isTwoLines = false;
            tds.forEach((td) => {
              if(td.offsetTop > 62) {
                isTwoLines = true;
              }
            })
            if(isTwoLines) {
              this.showingTwoLine = true;
            }
            else {
              this.showingTwoLine = false;
            }
          }
          this.showingTwoLineHidden = false;
        },0)
        this.preWindowWidth = window.innerWidth;
      }
    }
  },

  created() {
    window.addEventListener("resize", this.resizeWindowHandler);
    this.initDate = new Date();
    this.loadData();
  },

  destroyed() {
    window.removeEventListener("resize", this.resizeWindowHandler);
  },

  mounted() {
    this.$refs.detailMetricsCharts.addEventListener('scroll', ()=>{
      if(document.querySelector('.el-select-dropdown.el-popper.line-chart-dropdown')) {
        document.querySelector('.el-select-dropdown.el-popper.line-chart-dropdown').remove()
      }
    })
    
    this.preWindowWidth = window.innerWidth;
    if(document.querySelectorAll('.metrics-table tr > td') )
      document.querySelectorAll('.metrics-table tr > td').forEach((tds) => {
      let valueDiv = tds.querySelectorAll('div')[1].querySelectorAll('div')[1];
      if(valueDiv.offsetTop > 62) {
        this.showingTwoLine = true;
      }
    })
  }
});
</script>

<style lang="scss">
.wy-analytics-contact-reasons-detail-metrics {
  .metrics-table {
    width: 100%;

    > tr > td {
      box-sizing: border-box;
      border-right: 1px solid #e8e8e8;
      border-bottom: 1px solid #e8e8e8;
      height: 150px;
      padding: 20px 20px 20px 20px;
      vertical-align: top;
      color: #002852;
      cursor: pointer;

      .title {
        height: 35px;
        font-size: 15px;
      }
      .value.multiLines > .total {
        display: block;
      }
      .value.multiLines > .change {
        margin-left: 1px;
      }
      .value.hidden > .change{
        visibility: hidden;
      }
      .value {
        font-weight: bold;
        font-size: 24px;
        margin-bottom: 10px;

        div {
          display: inline-block;
        }
        .el-no-data {
          cursor: pointer;
          background-image: url('../../assets/icons/icon_comparison_data_not_available.svg') !important;
          background-size: 24%;
          background-repeat: no-repeat;
          background-position-y: 5px;
          background-position-x: 4px;
          background-color: transparent !important;
          border: 0px;
          margin-left: 8px;
          padding-left: 20px;
        }
        .el-no-data:hover {
          background-color: unset;
        }
        .change {
          font-size: 16px;
          margin-left: 12px;
        }
      }

      .change.up {
        color: #4448A2;
        .icon {
          background-image: url("../../assets/icons/icon_arrow_up.svg");
          color: #4448A2;
          background-size: 100%;
          background-position-x: 1px;
          background-position-y: 3px;
          background-repeat: no-repeat;
          height: 16px;
          width: 16px;
          display: inline-block
        }
      }
      .change.down {
        color: #3E6891;
        .icon {
          background-image: url("../../assets/icons/icon_arrow_down.svg");
          color: #8060A5;
          background-size: 100%;
          background-position-x: 1px;
          background-position-y: 3px;
          background-repeat: no-repeat;
          height: 16px;
          width: 16px;
          display: inline-block;
        }
      }

      .compare {
        font-size: 14px;
        
        .no-data {
          color: #002852;
          // font-weight: 500;
        }
      }
    }

    > tr > td.selected {
      border-bottom: 3px solid #214586;
      .title {
        color: #214586;
        font-weight: bold;
      }
      .value {
        color: #214586;
      }
    }

    > tr > td.showAllChart {
      border-bottom: 3px solid #214586;
      .title {
        color: #214586;
        font-weight: bold;
      }
      .value {
        color: #214586;
      }
    }

    > tr > td:last-child {
      border-right: none;
    }
  }

  .charts {
    padding: 20px 30px;
    // height: calc(100vh - 495px);
    overflow-y: hidden;
        
    .toolbar {
      margin-bottom: 10px;
      text-align: right;

      .viewCharts.el-button--primary {
        background-color: #214586;
        border-color: #214586 !important;
        box-shadow: 1px 1px 6px #0033664D;
        border-radius: 14px;
        padding: 7px;      
        width: 150px;
      }
    }
    div.chart {
      margin-bottom: 26px;      
      //box-shadow: 5px 5px 6px #00000029;
      //border-radius: 25px;
    }
  }
  
}
</style>